export default __webpack_public_path__ + "static/media/gridImage3.81b5aaeb.png";